// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"180":"App","475":"views"}[chunkId] || chunkId) + "." + {"180":"2bc2788e","455":"e13a7326","475":"81b5c7ab"}[chunkId] + ".chunk.css";
};